<template>
  <main class="admin-login">
    <img class="admin-login__logo admin-login__logo_desktop" src="../assets/mgmt_logo_big.svg" alt="Standard Model Management">
    <img class="admin-login__logo admin-login__logo_mobile" src="../assets/mgmt_logo_small.svg" alt="Standard Model Management">
    <validation-observer slim ref="form">
      <form @submit.prevent="submitForm" class="admin-login__form" novalidate>
        <validation-provider slim name="email" rules="required|email">
          <base-input
            class="admin-login__input"
            v-model="email"
            type="email"
            placeholder="Email"
            autocomplete="email"
            :error="inputError"
          ></base-input>
        </validation-provider>
        <validation-provider slim name="passwd" rules="required">
        <base-input
          class="admin-login__input"
          v-model="passwd"
          type="password"
          placeholder="Пароль"
          autocomplete="password"
          :error="inputError"
        ></base-input>
        </validation-provider>
        <base-button
          class="admin-login__button"
          type="submit"
        >
          войти
        </base-button>
      </form>
    </validation-observer>
  </main>
</template>

<script>
import BaseInput from '../components/BaseInput'
import BaseButton from '../components/BaseButton'

import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { extend } from 'vee-validate'
import { required, email } from 'vee-validate/dist/rules'

import { apiLoginUser } from '../utils/api'

extend('email', email)
extend('required', required)

export default {
  name: 'AdminLogin',
  components: {
    BaseInput,
    BaseButton,
    ValidationProvider,
    ValidationObserver
  },
  data() {
    return {
      email: '',
      passwd: '',
      inputError: false
    }
  },
  methods: {
    async submitForm() {
      let success = await this.$refs.form.validate()
      if (!success) {
        this.inputError = true
        setTimeout(() => this.inputError = false, 2000)
        return
      }
      try {
        await apiLoginUser(this.email, this.passwd)
        this.$router.push({ name: 'AdminHome'} )
      } catch(error) {
        this.inputError = true
        setInterval(() => this.inputError = false, 2000)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.admin-login {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  &__logo {
    position: fixed;
    top: 25px;
    &_desktop {
      width: 407px;
      left: 45px;
    }
    &_mobile {
      display: none;
      width: 170px;
      left: 12px;
    }
  }
  &__form {
    width: 290px;
  }
  &__input:nth-child(2) {
    margin: 10px 0 20px;
  }
  &__button {
    width: 100%;
  }
}

@media screen and (max-width: 767px) {
  .admin-login {
    &__logo {
      &_desktop {
        display: none;
      }
      &_mobile {
        display: block;
      }
    }
    &__button {
      position: fixed;
      bottom: 30px;
      left: calc((100vw - 290px) / 2);
      width: 290px;
    }
  }
}
</style>